export interface IProductSku {
  productName: string;
  activeUnits: number;
  consumedUnits: number;
  availableUnits: number;
}
export default class ProductSku {
  productName: string;
  activeUnits: number;
  consumedUnits: number;
  availableUnits: number;

  constructor(dto: IProductSku) {
    Object.assign(this, dto);
  }

  get getProductName(): string {
    return this.productName;
  }

  set setProductName(productName: string) {
    this.productName = productName;
  }

  get getActiveUnits(): number {
    return this.activeUnits;
  }

  set setActiveUnits(activeUnits: number) {
    this.activeUnits = activeUnits;
  }

  get getConsumedUnits(): number {
    return this.consumedUnits;
  }

  set setConsumedUnits(consumedUnits: number) {
    this.consumedUnits = consumedUnits;
  }

  get getAvailableUnits(): number {
    return this.availableUnits;
  }

  set setAvailableUnits(availableUnits: number) {
    this.availableUnits = availableUnits;
  }
}
